export const TestCSSQuestions = [
{
id: 1,
question: "What does CSS stand for?",
choices: {
a: "Cascading Style Sheets",
b: "Creative Style Sheets",
c: "Computerized Style Sheets",
d: "Colorful Style Sheets",
},
answer: "a",
},
{
id: 2,
question: "Which CSS property is used to control the size of a box?",
choices: {
a: "width",
b: "height",
c: "size",
d: "box-size",
},
answer: "a",
},
{
id: 3,
question: "How can you include a CSS file in your HTML document?",
choices: {
a: "<style src='styles.css'>",
b: "<css>styles.css</css>",
c: "<link rel='stylesheet' href='styles.css'>",
d: "<import src='styles.css'>",
},
answer: "c",
},
{
id: 4,
question: "Which CSS property is used to change the color of text?",
choices: {
a: "text-color",
b: "color",
c: "text-style",
d: "font-color",
},
answer: "b",
},
{
id: 5,
question: "Which CSS property is used to control the spacing between lines of text?",
choices: {
a: "line-height",
b: "letter-spacing",
c: "word-spacing",
d: "text-spacing",
},
answer: "a",
},
{
id: 6,
question: "Which CSS property is used to control the placement of an element in relation to its parent element?",
choices: {
a: "position",
b: "top",
c: "float",
d: "align",
},
answer: "a",
},
{
id: 7,
question: "Which CSS property is used to change the background color of an element?",
choices: {
a: "bgcolor",
b: "background-color",
c: "color",
d: "bg-color",
},
answer: "b",
},
{
id: 8,
question: "Which CSS property is used to create rounded corners for an element?",
choices: {
a: "border-radius",
b: "border-style",
c: "border-round",
d: "corner-radius",
},
answer: "a",
},
{
id: 9,
question: "What is the correct way to select an element with the class 'example' in CSS?",
choices: {
a: ".example",
b: "#example",
c: "*example",
d: "$example",
},
answer: "a",
},
{
id: 10,
question: "Which CSS property is used to control the spacing between words?",
choices: {
a: "word-spacing",
b: "letter-spacing",
c: "line-height",
d: "text-spacing",
},
answer: "a",
},
{
id: 11,
question: "What is the correct way to select an element with the ID 'example' in CSS?",
choices: {
a: ".example",
b: "#example",
c: "*example",
d: "$example",
},
answer: "b",
},
{
id: 12,
question: "Which CSS property is used to control the visibility of an element?",
choices: {
a: "display",
b: "visibility",
c: "opacity",
d: "hidden",
},
answer: "b",
},
{
id: 13,
question: "What does the CSS property 'float' do?",
choices: {
a: "It makes an element float above other elements",
b: "It makes an element sink below other elements",
c: "It changes the font size of an element",
d: "It changes the background color of an element",
},
answer: "a",
},
{
id: 14,
question: "Which CSS property is used to control the order of overlapping elements?",
choices: {
a: "z-index",
b: "order",
c: "overlap",
d: "layer",
},
answer: "a",
},
{
id: 15,
question: "Which CSS property is used to control the display behavior of an element?",
choices: {
a: "display",
b: "visibility",
c: "opacity",
d: "position",
},
answer: "a",
},
{
id: 16,
question: "Which CSS property is used to control the size of an element's margin?",
choices: {
a: "margin-size",
b: "padding",
c: "margin",
d: "margin-width",
},
answer: "c",
},
{
id: 17,
question: "What is the correct way to set the text color of an element to red in CSS?",
choices: {
a: "text-color: red;",
b: "color: red;",
c: "text-style: red;",
d: "font-color: red;",
},
answer: "b",
},
{
id: 18,
question: "Which CSS property is used to control the spacing between elements within a container?",
choices: {
a: "spacing",
b: "margin",
c: "padding",
d: "position",
},
answer: "c",
},
{
id: 19,
question: "What does the CSS property 'opacity' do?",
choices: {
a: "It changes the background color of an element",
b: "It makes an element float above other elements",
c: "It controls the visibility of an element",
d: "It changes the font size of an element",
},
answer: "c",
},
{
id: 20,
question: "Which CSS property is used to control the spacing between letters in a word?",
choices: {
a: "letter-spacing",
b: "word-spacing",
c: "line-height",
d: "text-spacing",
},
answer: "a",
},
{
id: 21,
question: "Which CSS property is used to change the size of an element's font?",
choices: {
a: "font-size",
b: "text-size",
c: "font-style",
d: "text-style",
},
answer: "a",
},
{
id: 22,
question: "Which CSS property is used to set the background color of an element?",
choices: {
a: "background",
b: "background-color",
c: "color",
d: "bgcolor",
},
answer: "b",
},
{
id: 23,
question: "What is the correct way to apply an external CSS file to an HTML document?",
choices: {
a: "<link rel='stylesheet' type='text/css' href='style.css'>",
b: "<style src='style.css'></style>",
c: "<style link='style.css'></style>",
d: "<link type='text/css' href='style.css'>",
},
answer: "a",
},
{
id: 24,
question: "Which CSS property is used to create rounded corners on an element?",
choices: {
a: "border-round",
b: "border-radius",
c: "border-corner",
d: "border-curve",
},
answer: "b",
},
{
id: 25,
question: "What is the correct way to center an element horizontally in CSS?",
choices: {
a: "margin-left: auto; margin-right: auto;",
b: "padding-left: auto; padding-right: auto;",
c: "text-align: center;",
d: "float: center;",
},
answer: "a",
},
{
id: 26,
question: "Which CSS property is used to control the position of an element relative to its parent element?",
choices: {
a: "position",
b: "display",
c: "float",
d: "z-index",
},
answer: "a",
},
{
id: 27,
question: "What is the correct way to select all the paragraphs inside a div element in CSS?",
choices: {
a: "div p",
b: "div > p",
c: "div + p",
d: "div ~ p",
},
answer: "a",
},
{
id: 28,
question: "Which CSS property is used to control the size of an element's padding?",
choices: {
a: "padding-size",
b: "margin",
c: "padding",
d: "padding-width",
},
answer: "c",
},
{
id: 29,
question: "What is the correct way to apply a background image to an element in CSS?",
choices: {
a: "background: url(image.jpg);",
b: "background-image: url(image.jpg);",
c: "img:background(url(image.jpg));",
d: "image: url(image.jpg);",
},
answer: "b",
},
{
id: 30,
question: "Which CSS property is used to control the spacing between lines of text?",
choices: {
  a: "text-align",
  b: "line-height",
  c: "word-spacing",
  d: "letter-spacing",
},
answer: "b",
},
{
id: 31,
question: "Which CSS property is used to control the spacing between letters of text?",
choices: {
  a: "text-align",
  b: "line-height",
  c: "word-spacing",
  d: "letter-spacing",
},
answer: "d",
},
{
id: 32,
question: "Which CSS property is used to control the visibility of an element?",
choices: {
  a: "display",
  b: "visibility",
  c: "opacity",
  d: "hidden",
},
answer: "b",
},
{
id: 33,
question: "What is the correct way to apply a shadow to an element in CSS?",
choices: {
  a: "shadow: 2px 2px 2px #000;",
  b: "box-shadow: 2px 2px 2px #000;",
  c: "text-shadow: 2px 2px 2px #000;",
  d: "shadow-color: #000; shadow-size: 2px; shadow-offset: 2px;",
},
answer: "b",
},
{
id: 34,
question: "Which CSS property is used to control the order of elements that overlap each other?",
choices: {
  a: "z-index",
  b: "position",
  c: "display",
  d: "order",
},
answer: "a",
},
{
id: 35,
question: "What is the correct way to set the text color of a link that has been clicked in CSS?",
choices: {
  a: "a:active { color: #000; }",
  b: "a:hover { color: #000; }",
  c: "a:visited { color: #000; }",
  d: "a:focus { color: #000; }",
},
answer: "c",
},
{
id: 36,
question: "Which CSS property is used to control the style of a list marker?",
choices: {
  a: "marker-style",
  b: "list-style",
  c: "list-marker",
  d: "marker-type",
},
answer: "b",
},
{
id: 37,
question: "What is the correct way to apply a transition effect to an element in CSS?",
choices: {
  a: "transition: property duration timing-function;",
  b: "transition-duration: property duration timing-function;",
  c: "transition-effect: property duration timing-function;",
  d: "transition-property: property; transition-duration: duration; transition-timing-function: timing-function;",
},
answer: "d",
},
{
id: 38,
question: "Which CSS property is used to control the order of elements in a flex container?",
choices: {
  a: "flex-order",
  b: "order",
  c: "flex-direction",
  d: "flex-align",
},
answer: "b",
},
{
  id: 39,
  question: "Which CSS property is used to control the alignment of items in a flex container along the cross-axis?",
  choices: {
    a: "flex-align",
    b: "align-items",
    c: "justify-content",
    d: "align-content",
  },
  answer: "b",
},
{
  id: 40,
  question: "What is the correct way to set the background image of an element in CSS?",
  choices: {
    a: "background: url('image.jpg');",
    b: "background-image: url('image.jpg');",
    c: "background-img: url('image.jpg');",
    d: "image: url('image.jpg');",
  },
  answer: "b",
}     

]

